import React, { useState, useEffect } from "react";
import { isEmpty } from "lodash";

import { DatePickerInputProps, DatePickerProps } from "types";

import DatePicker from ".";


const DatePickerRange = ({
	name,
	value,
	placeholderText,
	className,
	wrapperClassName,
	onChange,
	onBlur,
	onFocus,
	minDate,
	maxDate,
	monthsShown = 2,
	tabIndex,
	disabled,
}: DatePickerInputProps<true> & DatePickerProps) => {
	const [dateRange, setDateRange] = useState<[Date | null, Date | null]>([
		null,
		null,
	]);
	const [startDate, endDate] = dateRange;

	useEffect(() => {
		if (isEmpty(value)) {
			setDateRange([null, null]);
		}
	}, [value]);

	return (
		<DatePicker
			name={name}
			value={value}
			dateFormat="MM/dd/yyyy"
			onChange={value => {
				setDateRange(value);
				onChange(value, undefined);
			}}
			onBlur={onBlur}
			onFocus={onFocus}
			placeholderText={placeholderText}
			className={className}
			wrapperClassName={wrapperClassName}
			minDate={minDate}
			maxDate={maxDate}
			startDate={startDate}
			endDate={endDate}
			monthsShown={monthsShown}
			tabIndex={tabIndex}
			disabled={disabled}
			selectsRange={true}
		/>
	);
};

export default DatePickerRange;
